import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=58ea6b0a"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=58ea6b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports